export class Version {
  public static fromString(version: string): Version {
    const versionParts: Array<string> = version.split('.');
    const major: number = Version.parseNumber(versionParts[0]);
    const minor: number = Version.parseNumber(versionParts[1]);
    let patchParts: Array<string>;
    let patch: number;
    let label: string;

    // If patch contains labels
    if (versionParts[2] && versionParts[2].indexOf('-') > 0) {
      patchParts = versionParts[2].split('-');
      if (patchParts.length > 1) {
        patch = Version.parseNumber(patchParts[0]);
        label = patchParts.slice(1).join('-');
        if (versionParts[3]) {
          label += `-${versionParts[3]}`;
        }
      }
    } else {
      patch = Version.parseNumber(versionParts[2]);
    }

    return new Version(major, minor, patch, label);
  }

  public static parseNumber(numberString: string): number {
    const number: number = parseInt(numberString, 10);
    if (isNaN(number) || number == null) {
      return 0;
    } else {
      return number;
    }
  }

  constructor(
    public major: number,
    public minor: number,
    public patch?: number,
    public label?: string
  ) {}

  public toString: Function = (): string => {
    let versionString: string;
    versionString = this.major + '.' + this.minor;
    if (this.patch) {
      versionString += '.' + this.patch;
    }
    if (this.label) {
      versionString += '-' + this.label;
    }
    return versionString;
  };

  public compareVersions(otherVersion: Version): number {
    if (otherVersion.major === this.major) {
      if (otherVersion.minor === this.minor) {
        return otherVersion.patch - this.patch;
      } else {
        return otherVersion.minor - this.minor;
      }
    } else {
      return otherVersion.major - this.major;
    }
  }

  public isGreaterOrEqualThen(otherVersion: Version): boolean {
    return this.compareVersions(otherVersion) <= 0;
  }

  public isGreaterThen(otherVersion: Version): boolean {
    return this.compareVersions(otherVersion) < 0;
  }
}
